import(/* webpackMode: "eager" */ "C:\\Users\\hp\\Documents\\GitHub\\emergeweb\\src\\app\\certificate\\page.tsx");
